import { Sku } from '../domain/entities/Sku';

export const formatVersionNumber = (versionNumber: string) => {
    if (versionNumber) {
        return `&lt;${versionNumber}&gt;`;
    }

    return '';
};

export const buildIngredientsContent = (selectedSku: Sku) => {
    return selectedSku && selectedSku.ingredients
        ? `${selectedSku.ingredients} ${formatVersionNumber(selectedSku.versionNumber)}`
        : '';
};

export const decodeHtml = (html: string) => {
    const txt = document.createElement('textarea');
    txt.innerHTML = html;

    return txt.value;
};

export const sanitizeJsonForQuery = (jsonString: string) => {
    return jsonString.replace(/\"([^(\")"]+)\":/g, '$1:');
};
